import React, { Component } from 'react';
import './ArticleList.css';

export default class ArticelList extends Component {
  render() {
    return (
    	<div className={"ArticleList"}>
    		 {this.props.children}
    	</div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ArticleList/ArticleList.js